// extracted by mini-css-extract-plugin
module.exports = {"completed":"MfMbj1IVkeKJ67QO4OWwn","form":"_3akOaUViObBCioDuwHK6uc"};